import { render, staticRenderFns } from "./ClientForm.vue?vue&type=template&id=74324e58&scoped=true"
import script from "./ClientForm.vue?vue&type=script&lang=ts"
export * from "./ClientForm.vue?vue&type=script&lang=ts"
import style0 from "./ClientForm.vue?vue&type=style&index=0&id=74324e58&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74324e58",
  null
  
)

export default component.exports